import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUpload, faTrash, faPlus } from '@fortawesome/free-solid-svg-icons';
import { VISA_DOCUMENT_TYPES } from '../constants/visaFormOptions';
import DocumentFileActions from './DocumentFileActions';

const API_URL = process.env.REACT_APP_API_URL || 'https://unilinkapi-production.up.railway.app';

export default function VisaDocumentSlots({
  documents = [],
  pendingByType = {},
  onQueueFile,
  onRemovePending,
  onUpload,
  onDelete,
  uploadingType = '',
  viewOnly = false,
  showPending = false,
}) {
  const docsForType = (type) => documents.filter((d) => d.document_type === type);
  const pendingForType = (type) => pendingByType[type] || [];

  return (
    <div className="form-section">
      <h2 className="section-title">Documents Upload</h2>
      <div className="row g-3">
        {VISA_DOCUMENT_TYPES.map((type) => {
          const files = docsForType(type);
          const pending = pendingForType(type);
          const hasFiles = files.length > 0 || pending.length > 0;
          return (
            <div key={type} className="col-md-6">
              <div style={{
                border: hasFiles ? '2px solid #22c55e' : '2px dashed #d1d5db',
                borderRadius: '12px',
                padding: '16px',
                background: hasFiles ? '#f0fdf4' : '#fafafa',
              }}>
                <div style={{ fontWeight: 600, marginBottom: '8px', display: 'flex', alignItems: 'center', gap: '8px' }}>
                  {type}
                  {!viewOnly && <FontAwesomeIcon icon={faPlus} style={{ fontSize: '11px', color: '#6b7280' }} />}
                </div>
                {files.map((doc) => (
                  <div key={doc.id} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '8px', marginBottom: '8px' }}>
                    <span style={{ fontSize: '12px', color: '#374151', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                      {doc.original_name || 'Uploaded file'}
                    </span>
                    <div style={{ display: 'flex', gap: '6px', flexShrink: 0, alignItems: 'center' }}>
                      <DocumentFileActions
                        fileUrl={`${API_URL}${doc.file_path}`}
                        fileName={doc.original_name || 'document'}
                      />
                      {!viewOnly && onDelete && (
                        <button type="button" className="btn-icon btn-delete" onClick={() => onDelete(doc.id)}>
                          <FontAwesomeIcon icon={faTrash} />
                        </button>
                      )}
                    </div>
                  </div>
                ))}
                {showPending && pending.map((file, idx) => (
                  <div key={`${type}-pending-${idx}`} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '8px', marginBottom: '8px' }}>
                    <span style={{ fontSize: '12px', color: '#374151' }}>{file.name} (pending)</span>
                    {!viewOnly && onRemovePending && (
                      <button type="button" className="btn-icon btn-delete" onClick={() => onRemovePending(type, idx)}>
                        <FontAwesomeIcon icon={faTrash} />
                      </button>
                    )}
                  </div>
                ))}
                {!viewOnly && (
                  <label className="btn-secondary btn-sm" style={{ cursor: 'pointer', margin: 0 }}>
                    <FontAwesomeIcon icon={faUpload} />
                    {' '}
                    {uploadingType === type ? 'Uploading...' : 'Add File'}
                    <input
                      type="file"
                      accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                      style={{ display: 'none' }}
                      disabled={uploadingType === type}
                      onChange={(e) => {
                        const file = e.target.files?.[0];
                        e.target.value = '';
                        if (!file) return;
                        if (onUpload) onUpload(type, file);
                        else if (onQueueFile) onQueueFile(type, file);
                      }}
                    />
                  </label>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
